module.exports = __webpack_public_path__ + "img/hand-right-bottom.b9b8fd88.png";